<template>
<span>
    <span v-if="((parseInt(news.hidden) > 0) && (Date.parse(news.datetime) > Date.now()) )" class="fa-stack fa-1x mr-1" style="width:1em; height:1em; line-height:1em;" title="Nascosta e In attesa">
        <i class="fa-regular fa-clock fa-stack-1x" ></i>
        <i class="fa-solid fa-slash fa-stack-1x" style="color:#fb5858"></i>
    </span>

    <span v-else-if="(parseInt(news.hidden) > 0)" class="fa-stack fa-1x mr-1" style="width:1em; height:1em; line-height:1em;" title="Nascosta">
        <i class="fa-regular fa-eye fa-stack-1x"></i>
        <i class="fa-solid fa-slash fa-stack-1x" style="color:#fb5858"></i>
    </span>

    <span v-else-if="(news.endtime && Date.parse(news.endtime) < Date.now())" class="fa-stack fa-1x mr-1" style="width:1em; height:1em; line-height:1em;" title="Scaduta">
        <i class="fa-regular fa-clock fa-stack-1x" ></i>
        <i class="fa-solid fa-slash fa-stack-1x" style="color:#fb5858"></i>
    </span>

    <span v-else-if="(Date.parse(news.datetime) > Date.now())" class="fa-stack fa-1x mr-1" style="width:1em; height:1em; line-height:1em;" title="In attesa">
        <i class="fa-regular fa-clock fa-stack-1x"></i>
        <i class="fa-regular fa-circle fa-stack-1x" style="color:#28a745"></i>
    </span>

    <i v-else-if="(Date.parse(news.datetime) < Date.now())" class="fa-regular fa-eye fa-1x mr-1" style="color:#28a745;" title="Visibile"></i>
    
    <i class="fa-solid fa-user-pen mr-1 text-danger" v-if="isLocked()" :title="getLockUsers()"></i>
</span>
</template>
<script setup>
import { format, formatDistance, formatRelative, subDays, parseISO } from 'date-fns'
import { it } from 'date-fns/locale';

const props = defineProps({
    news: {
        type: Object,
        required: true
    },
    locks: {
        type: Array,
        required: false
    },
    type: {
        type: String,
        required: true
    }
});

function isLocked() {
    if(props.type == "draft") {
        return (props.locks?.findIndex( (lock) => lock.record_id == props.news.uuid) > -1);
    } else {
        return (props.locks?.findIndex( (lock) => lock.record_id == props.news.newspaper_id.split("-")[0] + "-" + props.news.uid) > -1);
    }
    
}

function getLocks() {
    let locks = [];
    if(props.type == "draft") {
        locks = props.locks?.filter( (lock) => {
            return lock.record_id == props.news.uuid;
        });
    } else {
        locks = props.locks?.filter( (lock) => {
            return lock.record_id == props.news.newspaper_id.split("-")[0] + "-" + props.news.uid;
        });
    }
    return locks;
}

function getLockUsers() {
    return getLocks().map( (lock) => lock.user.email + " (ha iniziato a lavorare su questa news " + formatDistance(parseISO(lock.updated_at), new Date(), { addSuffix: true, locale: it }) + ")" ).join(', ');
}
</script>